// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.historyBlock__a9Eqk {
  height: 100%;
}

.blockTitle__O6Ip6 {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  min-height: 20px;
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.blockContainer__Jeyz1 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 20px);
  min-height: 100px;
  position: relative;
  background-color: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}

.emptyDataBlock__VR6Db {
  font-size: 12px;
  text-transform: uppercase;
  color: var(--tables-secondary-row-sub-title-text);
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.infoTitle__Cevfe {
  font-size: 12px;
  line-height: 18px;
  color: var(--tables-primary-row-text-main);
}

.infoDate__SofzQ {
  font-size: 12px;
  line-height: 16px;
  color: var(--tables-primary-row-text-additional);
  margin-top: 5px;
  margin-bottom: 0;
}

.infoText__j8B9I {
  font-size: 12px;
  line-height: 18px;
  color: var(--tables-primary-row-text-main);
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.infoText__j8B9I p {
  margin: 0;
}

.viewHistoryBtn__Ocjs4 {
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: var(--buttons-text-secondary);
  text-transform: uppercase;
  text-decoration: none;
  text-align: right;
  cursor: pointer;
  margin-left: auto;
}

.historyAiTable__M8k6U {
  width: 100%;
}
.historyAiTable__M8k6U thead {
  background-color: var(--tables-title-surface);
}
.historyAiTable__M8k6U th {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--tables-title-text);
  text-transform: uppercase;
  text-align: left;
  min-width: 130px;
  padding: 15px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  position: sticky;
  top: 0;
}
.historyAiTable__M8k6U th:first-child {
  padding-left: 25px;
}
@media (max-width: 1400px) {
  .historyAiTable__M8k6U th {
    min-width: none;
  }
}
.historyAiTable__M8k6U .statusTh__dQVPu {
  min-width: 70px;
  text-align: right;
}
.historyAiTable__M8k6U tr {
  cursor: pointer;
}
.historyAiTable__M8k6U tr:hover {
  background-color: var(--tables-primary-row-surface-hover);
}
.historyAiTable__M8k6U td {
  font-size: 14px;
  line-height: 17px;
  padding: 15px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.historyAiTable__M8k6U td:first-child {
  padding-left: 25px;
}

.alignRight__xP_re {
  text-align: right;
}

.buttonsContainer__HUQwz {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  padding: 25px;
}

.addIcon__I9EVW path {
  fill: var(--buttons-text-secondary);
}

.skeletonText__VKqzi {
  width: 100%;
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/EquipmentDetails/components/EquipmentDetailsAIHistory/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2DAAA;EACA,wCAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,yBAAA;EACA,iDAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,gDAAA;EACA,eAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,SAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAzEF;AA4EI;EACE,SAAA;AA1EN;;AA+EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AA5EF;;AA+EA;EACE,WAAA;AA5EF;AA8EE;EACE,6CAAA;AA5EJ;AA+EE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,yDAAA;EACA,gBAAA;EACA,MAAA;AA7EJ;AA+EI;EACE,kBAAA;AA7EN;AAgFI;EAjBF;IAkBI,eAAA;EA7EJ;AACF;AAgFE;EACE,eAAA;EACA,iBAAA;AA9EJ;AAiFE;EACE,eAAA;AA/EJ;AAiFI;EACE,yDAAA;AA/EN;AAmFE;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,yDAAA;AAjFJ;AAmFI;EACE,kBAAA;AAjFN;;AAsFA;EACE,iBAAA;AAnFF;;AAsFA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;AAnFF;;AAuFE;EACE,mCAAA;AApFJ;;AAwFA;EACE,WAAA;EACA,YAAA;AArFF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.historyBlock {\n  height: 100%;\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  min-height: 20px;\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.blockContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: calc(100% - 20px);\n  min-height: 100px;\n  position: relative;\n  background-color: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n}\n\n.emptyDataBlock {\n  font-size: 12px;\n  text-transform: uppercase;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.infoTitle {\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--tables-primary-row-text-main);\n}\n\n.infoDate {\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--tables-primary-row-text-additional);\n  margin-top: 5px;\n  margin-bottom: 0;\n}\n\n.infoText {\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--tables-primary-row-text-main);\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  :global {\n    p {\n      margin: 0;\n    }\n  }\n}\n\n.viewHistoryBtn {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--buttons-text-secondary);\n  text-transform: uppercase;\n  text-decoration: none;\n  text-align: right;\n  cursor: pointer;\n  margin-left: auto;\n}\n\n.historyAiTable {\n  width: 100%;\n\n  thead {\n    background-color: var(--tables-title-surface);\n  }\n\n  th {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    color: var(--tables-title-text);\n    text-transform: uppercase;\n    text-align: left;\n    min-width: 130px;\n    padding: 15px;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    position: sticky;\n    top: 0;\n\n    &:first-child {\n      padding-left: 25px;\n    }\n\n    @media (max-width: 1400px) {\n      min-width: none;\n    }\n  }\n\n  .statusTh {\n    min-width: 70px;\n    text-align: right;\n  }\n\n  tr {\n    cursor: pointer;\n\n    &:hover {\n      background-color: var(--tables-primary-row-surface-hover);\n    }\n  }\n\n  td {\n    font-size: 14px;\n    line-height: 17px;\n    padding: 15px;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n    &:first-child {\n      padding-left: 25px;\n    }\n  }\n}\n\n.alignRight {\n  text-align: right;\n}\n\n.buttonsContainer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: auto;\n  padding: 25px;\n}\n\n.addIcon {\n  path {\n    fill: var(--buttons-text-secondary);\n  }\n}\n\n.skeletonText {\n  width: 100%;\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"historyBlock": `historyBlock__a9Eqk`,
	"blockTitle": `blockTitle__O6Ip6`,
	"blockContainer": `blockContainer__Jeyz1`,
	"emptyDataBlock": `emptyDataBlock__VR6Db`,
	"infoTitle": `infoTitle__Cevfe`,
	"infoDate": `infoDate__SofzQ`,
	"infoText": `infoText__j8B9I`,
	"viewHistoryBtn": `viewHistoryBtn__Ocjs4`,
	"historyAiTable": `historyAiTable__M8k6U`,
	"statusTh": `statusTh__dQVPu`,
	"alignRight": `alignRight__xP_re`,
	"buttonsContainer": `buttonsContainer__HUQwz`,
	"addIcon": `addIcon__I9EVW`,
	"skeletonText": `skeletonText__VKqzi`
};
module.exports = ___CSS_LOADER_EXPORT___;
